/*
 *
 */
export class GridModelSetting {
	constructor(public clusters: Array<number>, public rowsWithoutCb: Array<number>, public rows: Array<Array<any>>) {}
}
